import yaml from "js-yaml";

export const YamlView = ({ data, ...props }) => {
  if (!data) return null;
  const yamlText = yaml.dump(data);

  return (
    <pre {...props} className="YamlView">
      {yamlText}
    </pre>
  );
};
